// import Some from "../images/ProjectsImages/"
export const projectsObj = [
  {
    title: "Amazon Clone",
    description: "A fully responsive Amazon Clone developed using React, featuring dynamic product listings, a powerful search functionality, and an intuitive UI.",
    link: "https://venkata-sanjeeva.github.io/amazon-clone/",
    location: "amazon-clone.png"
  },
  {
    title: "Tic Tac Toe Game",
    description: "A classic Tic Tac Toe game built with React, designed for a smooth and interactive user experience. The game features real-time gameplay with instant winner detection, a replay option for continuous fun.",
    link: "https://venkata-sanjeeva.github.io/tic-tac-toe-game/",
    location: "tic-tac-toe-game.png"
  },
  {
    title: "Portfolio - Bharat Intern",
    description: "This is a part of my Bharat Intern Project. Which tells about my skills and academic projects.",
    link: "https://venkata-sanjeeva.github.io/Sanjeeva-Portfolio/",
    location: "Portfolio-img.png"
  },
  {
    title: "Temperature Converter - Bharat Intern",
    description: "This will convert the temperature into Celsius and Fahrenheit.",
    link: "https://venkata-sanjeeva.github.io/temp-converter/",
    location: "Temp-conv.png"
  },
  {
    title: "Weather Report - Bharat Intern",
    description: "Here, you can get weather report details of corresponding locations you searched.",
    link: "https://venkata-sanjeeva.github.io/weather-report/",
    location: "Weather-Report.png"
  },
  {
    title: "Count Down Timer - InnovixionTech",
    description: "Here, you can set a timer to complete your task before the timer goes off.",
    link: "https://venkata-sanjeeva.github.io/InnovixionTech-Mar1-countdowntimer/",
    location: "CountDownTimer.png"
  },
  {
    title: "ToDo List - InnovixionTech",
    description: "By using this website, you can add your upcoming tasks in your daily life. Also, it uses CRUD operations.",
    link: "https://venkata-sanjeeva.github.io/InnovixionTech-Mar1-ToDoList/",
    location: "TodoList-Innovixian.png"
  },
  {
    title: "ToDo List - OctaNet",
    description: "By using this website, you can add your upcoming tasks in your daily life. Also, it prevents the tasks from being lost if you refresh the page.",
    link: "https://venkata-sanjeeva.github.io/OCTANET_APRIL-ToDo-List/",
    location: "TodoList-OctaNet.png"
  },
  {
    title: "Calculator",
    description: "Here, you can perform mathematical operations, and it will save the result even if you refresh the page.",
    link: "https://venkata-sanjeeva.github.io/calculator/",
    location: "Calculator.png"
  },
  {
    title: "Rock Paper Scissor Game",
    description: "This is a simple game where you pick a move from the options, the computer picks another move, and it checks both moves and returns the score.",
    link: "https://venkata-sanjeeva.github.io/rock-paper-scissor-game/",
    location: "RockpaperscissorGame.png"
  },
  {
    title: "Tribute Page",
    description: "A visually appealing tribute page created using HTML and CSS to honor ENCRYPTIX. The page features a clean, responsive design that ensures a seamless viewing experience across all devices.",
    link: "https://venkata-sanjeeva.github.io/ENCRYPTIX-Tribute-Page/",
    location: "tribute-page.png"
  },
  {
    title: "Nature Calls Landing Page",
    description: `A beautifully crafted landing page titled "Nature Calls," developed using HTML, CSS, and JavaScript. This project features a captivating design that highlights the beauty of nature, with smooth animations.`,
    link: "https://venkata-sanjeeva.github.io/OCTANET_MAY-naturecalls-landingpage/",
    location: "nature-calls-landingPage.png"
  }
];
